module.exports = __webpack_public_path__ + "static/media/FacingSunOfHimalaya.34c187ec.jpg";